<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
 

      <!--start new row-->
      
      <div class="row" style="margin-top:50px;">
     	<div class="col-xl-12">
     		 <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">Your Digital Mailbox</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="mails">
            <el-table-column label="Title"
                             prop="document_name"                              
                             min-width="340px"
                             >
                <template slot-scope="scope"> 
                	<span style="cursor:pointer;" @click="viewMail(scope.row.id)">	{{scope.row.document_name}} </span>
                </template>
            </el-table-column>
		   
            
            <el-table-column label="Remarks"
                             prop="notes"
                             min-width="140px"
                             >
            </el-table-column>
            
            
            <el-table-column label="Uploaded"
                             prop="uploaded_at_str"
                             min-width="120px"
                             >
            </el-table-column>
            

            
             <el-table-column label="" >
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewMail(scope.row.id)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
        	
        	
          
        </el-table>
    </div>
		</div>
	 </div>


    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import { Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  		 [Table.name]: Table,
     	 [TableColumn.name]: TableColumn,
    },
    data() {
      return {
     	 mails:[],
	
      };
    },
    methods: {
       viewMail(mid){
      			this.$router.push( '/view-mail/'+ mid);
        },
    },
    mounted() {
       swal.showLoading();
      
 		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_mails/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.mails = response.data.mails;
   			 swal.close();
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














